import React from 'react';
import { LeaderboardCategory, CATEGORY_CONFIG } from 'types/interfaces/leaderboard';
import './LeaderboardTabs.css';

interface LeaderboardTabsProps {
  activeCategory: LeaderboardCategory;
  onCategoryChange: (category: LeaderboardCategory) => void;
}

const CATEGORIES: LeaderboardCategory[] = [
  'most_trades',
  'most_cards_sent',
  'most_points',
  'highest_rated',
  'rising_stars',
  'new_members',
];

const LeaderboardTabs: React.FC<LeaderboardTabsProps> = ({
  activeCategory,
  onCategoryChange,
}) => {
  return (
    <div className="leaderboard-tabs">
      {CATEGORIES.map((category) => (
        <button
          key={category}
          className={`leaderboard-tab ${activeCategory === category ? 'leaderboard-tab--active' : ''}`}
          onClick={() => onCategoryChange(category)}
        >
          {CATEGORY_CONFIG[category].label}
        </button>
      ))}
    </div>
  );
};

export default LeaderboardTabs;
